import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { QrCodeModule } from 'ng-qrcode';
import { PrintService } from '../services/print.service';

@Component({
  selector: 'app-print-pallet',
  templateUrl: './print-pallet.component.html',
  styleUrl: './print-pallet.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [QrCodeModule],
})
export class PrintPalletComponent implements OnInit {
  private readonly printService = inject(PrintService);

  palletId: string | undefined;

  ngOnInit(): void {
    this.palletId = this.printService.palletId;
  }
}
